import { observer } from "mobx-react-lite";
import React, { type PropsWithChildren } from "react";
import { YStack } from "tamagui";
import { useStores } from "../../core/stores";
import { Box } from "../../ui/Box";
import { Label } from "../../ui/Label";
import { Screen } from "../../ui/Screen";

export const BusinessAdminDevGate = observer(
  ({ children }: PropsWithChildren) => {
    const { sessionStore } = useStores();

    const hasAccess = sessionStore.superUser.data.isDev === true;

    return (
      <Screen>
        {!hasAccess && (
          <Box>
            <YStack>
              <Label>
                Please login to access this. ({sessionStore.superUser.uid})
              </Label>
            </YStack>
          </Box>
        )}
        {hasAccess && children}
      </Screen>
    );
  },
);

export default BusinessAdminDevGate;
